// The timeline's own controls, bottom-right like the live map's
// (LiveMapControls): zoom the hours, fit the day back to the width, and full
// screen. The same control primitive, so both screens speak one language.

import {
  ArrowsInIcon,
  ArrowsInLineHorizontalIcon,
  ArrowsOutIcon,
  MagnifyingGlassMinusIcon,
  MagnifyingGlassPlusIcon,
} from "@phosphor-icons/react";
import { MapControlButton, MapControlGroup } from "@bednbody/ui/components/map-control";

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 4;

interface CalendarControlsProps {
  zoom: number;
  onZoomChange: (zoom: number) => void;
  isFullscreen: boolean;
  onToggleFullscreen: () => void;
}

export function CalendarControls({
  zoom,
  onZoomChange,
  isFullscreen,
  onToggleFullscreen,
}: CalendarControlsProps) {
  return (
    <MapControlGroup className="pointer-events-auto" orientation="horizontal">
      <MapControlButton
        disabled={zoom <= MIN_ZOOM}
        icon={<MagnifyingGlassMinusIcon className="size-5" />}
        label="Zoom out on hours"
        onClick={() => onZoomChange(Math.max(MIN_ZOOM, zoom - 0.5))}
        size="compact"
      />
      <MapControlButton
        disabled={zoom >= MAX_ZOOM}
        icon={<MagnifyingGlassPlusIcon className="size-5" />}
        label="Zoom in on hours"
        onClick={() => onZoomChange(Math.min(MAX_ZOOM, zoom + 0.5))}
        size="compact"
      />
      <MapControlButton
        active={zoom === MIN_ZOOM}
        icon={<ArrowsInLineHorizontalIcon className="size-5" />}
        label="Fit day"
        onClick={() => onZoomChange(MIN_ZOOM)}
        size="compact"
        text="Fit day"
        tone={zoom === MIN_ZOOM ? "active" : "surface"}
      />
      <MapControlButton
        active={isFullscreen}
        icon={
          isFullscreen ? <ArrowsInIcon className="size-5" /> : <ArrowsOutIcon className="size-5" />
        }
        label={isFullscreen ? "Exit full screen" : "Full screen"}
        onClick={onToggleFullscreen}
        size="compact"
        tone={isFullscreen ? "active" : "surface"}
      />
    </MapControlGroup>
  );
}
